import { Component, Input } from '@angular/core';

@Component({
	selector: 'ui-task-priority',
	template: `
		<div *ngIf="priority" class="text-center">
			<div>
				<span style="text-transform: uppercase; font-size: 0.75rem;" class="badge bg-{{getPriorityColor()}}-25 text-{{getPriorityColor()}}">{{getPriorityText()}}</span>
			</div>
		</div>
	`
})
export class UITaskPriorityComponent {

	@Input() priority;

	status_map = {};

	constructor() {
		this.status_map[0] = { color: 'success', text: 'Low' };
		this.status_map[1] = { color: 'warning', text: 'Medium' };
		this.status_map[2] = { color: 'primary', text: 'High' };
	}

	getPriorityColor(): string {
		return this.status_map[this.priority].color || 'success';
	}

	getPriorityText(): string {
		return this.status_map[this.priority].text || 'Low';
	}

}
